import * as React from 'react';
import { DVSClientContext } from '@doordash/lib-dvs-client/lib/react';
import Loading from '@doordash/component-loading';
export var DVSLoader = function (_a) {
    var children = _a.children;
    var state = React.useContext(DVSClientContext).state;
    if (state === 'ready') {
        // if state is 'ready', we can use the latest evaluated DVs
        return React.createElement(React.Fragment, null, children);
    }
    // if state is 'loading' or 'empty', render the loading spinner:
    return (React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 }));
};
